import cookies from 'js-cookie';

var MAX_EXPIRE_DATE = 2147483647000;
var CookieService = /** @class */ (function () {
    function CookieService() {
    }
    CookieService.prototype.read = function (name) {
        return cookies.get(name);
    };
    CookieService.prototype.write = function (name, value, options) {
        if (options && options.permanent) {
            // Maximum date
            options.expires = new Date(MAX_EXPIRE_DATE);
        }
        cookies.set(name, value, options);
    };
    return CookieService;
}());

export { CookieService };
